import { Dispatch, State } from '../use_candidate_profile';
import { UploadingDocument } from 'candidate_profile_redesign/shared/types';

import uuid from 'uuid';

type AddUploadingDocument = {
  type: 'addUploadingDocument';
  payload: Array<UploadingDocument>;
};

export const addUploadingDocuments =
  (_: State, dispatch: Dispatch) => (fileNames: Array<string>) => {
    return fileNames.map((fileName) => {
      const loadingDocument: UploadingDocument = {
        id: uuid.v4(),
        name: fileName,
      };

      dispatch({ type: 'addUploadingDocument', payload: [loadingDocument] });

      return loadingDocument;
    });
  };

type DeleteUploadingDocument = {
  type: 'deleteUploadingDocument';
  payload: Array<UploadingDocument>;
};

export const removeLoadingDocuments =
  (_: State, dispatch: Dispatch) =>
  (loadingDocuments: Array<UploadingDocument>) => {
    dispatch({
      type: 'deleteUploadingDocument',
      payload: loadingDocuments,
    });
  };

export type Actions = AddUploadingDocument | DeleteUploadingDocument;
